var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "colorForm",
              attrs: {
                model: _vm.colorForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.color") },
                },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: { predefine: _vm.predefineColors },
                    on: { change: _vm.changeBackgroundStyle },
                    model: {
                      value: _vm.colorForm.color,
                      callback: function ($$v) {
                        _vm.$set(_vm.colorForm, "color", $$v)
                      },
                      expression: "colorForm.color",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.not_alpha") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: { change: _vm.changeBackgroundStyle },
                    model: {
                      value: _vm.colorForm.alpha,
                      callback: function ($$v) {
                        _vm.$set(_vm.colorForm, "alpha", $$v)
                      },
                      expression: "colorForm.alpha",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item form-item-slider",
                  attrs: { label: _vm.$t("chart.border_radius") },
                },
                [
                  _c("el-slider", {
                    attrs: {
                      "show-input": "",
                      "show-input-controls": false,
                      "input-size": "mini",
                    },
                    on: { change: _vm.changeBackgroundStyle },
                    model: {
                      value: _vm.colorForm.borderRadius,
                      callback: function ($$v) {
                        _vm.$set(_vm.colorForm, "borderRadius", $$v)
                      },
                      expression: "colorForm.borderRadius",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }